import { View, TouchableOpacity, Text } from "react-native";
import React, { useEffect } from "react";
import { SafeAreaView } from "react-native";
import FeaturedRow from "../components/FeaturedRow";
import { useQuiz } from "../useContext/useQuiz";
import { FlatList } from "react-native-gesture-handler";
import LoadingScreen from "./LoadingScreen";
import Icon from "react-native-vector-icons/MaterialCommunityIcons"; // Or any other icon set you prefer
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
} from "react-native-reanimated";
import { useNavigation } from "@react-navigation/native";

const HomeScreen = () => {
  const { categories, subscription, getGenericData } = useQuiz();
  const navigation = useNavigation(); // Hook to access navigation object

  // Animation values
  const scale = useSharedValue(1);

  useEffect(() => {
    if (!categories) {
      getGenericData();
    }
  }, [categories]);

  // Animated style for the button
  const animatedButtonStyle = useAnimatedStyle(() => {
    return {
      transform: [{ scale: scale.value }],
    };
  });

  const handlePressIn = () => {
    scale.value = withSpring(0.7); // Shrink slightly on press
  };

  const handlePressOut = () => {
    scale.value = withSpring(1); // Return to original size
  };

  const navigateToPrintPage = () => {
    // Navigate to your printing page component
    navigation.navigate("Printers"); // Make sure "PrintingPage" is defined in your navigator
  };

  if (!categories && !subscription) return <LoadingScreen />;

  return (
    <SafeAreaView
      className="flex-1 bg-whiteBackground"
      style={{ direction: "rtl" }}
    >
      <View className="bg-whiteBackground flex-1">
        <FlatList
          data={categories}
          keyExtractor={(item) => item.id}
          contentContainerStyle={{ paddingBottom: 80 }}
          renderItem={({ item }) => (
            <FeaturedRow
              order={item.order}
              title={item.name}
              description={item.description}
              innerDescription={item.innerDescription}
              exercises={item.exercises}
              iconName={item.iconName}
              bgColor={item.bgColor}
            />
          )}
          ListFooterComponent={
            <View className="items-center my-8">
              <TouchableOpacity
                onPressIn={handlePressIn}
                onPressOut={handlePressOut}
                onPress={navigateToPrintPage}
                activeOpacity={1}
                className="flex-row items-center justify-center p-4 rounded-xl shadow-lg"
                style={{
                  backgroundColor: "#a8c7fa",
                  width: "80%",
                }}
              >
                <Animated.View
                  style={[
                    animatedButtonStyle,
                    {
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                    },
                  ]}
                >
                  <Icon name="printer" size={28} color="#000" />
                  <Text className="text-black text-lg font-semibold ml-3">
                    להדפסת מבחנים
                  </Text>
                </Animated.View>
              </TouchableOpacity>
            </View>
          }
        />
      </View>
    </SafeAreaView>
  );
};

export default HomeScreen;
